class HeroSlideshow {
    constructor(heroElement) {
        this.hero = heroElement;
        this.dots = Array.from(this.hero.querySelectorAll('.cs-dot'));
        this.slides = Array.from(this.hero.querySelectorAll('.cs-background'));
        this.counter = this.hero.querySelector('.cs-current');
        this.prevBtn = this.hero.querySelector('.cs-prev');
        this.nextBtn = this.hero.querySelector('.cs-next');
        this.currentSlide = 0;
        this.totalSlides = this.slides.length;
        this.slideDuration = 7000;
        this.slideInterval = null;

        this.init();
    }

    init() {
        this.slides.forEach((slide, index) => {
            slide.style.opacity = index === 0 ? '1' : '0';
        });

        this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => this.handleDotClick(index));
        });

        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', () => {
                const prevIndex = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
                this.goToSlide(prevIndex);
                this.resetSlideshow();
            });
        }

        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', () => {
                this.nextSlide();
                this.resetSlideshow();
            });
        }

        this.activateDot(0);
        this.updateCounter(0);
        this.startSlideshow();
    }

    activateDot(index) {
        this.dots[index].classList.add('cs-active');
    }

    deactivateDot(index) {
        this.dots[index].classList.remove('cs-active');
    }

    updateCounter(index) {
        if (this.counter) {
            this.counter.textContent = String(index + 1).padStart(2, '0');
        }
    }

    goToSlide(slideIndex) {
        this.deactivateDot(this.currentSlide);
        this.slides[this.currentSlide].style.opacity = '0';
        this.currentSlide = slideIndex;

        requestAnimationFrame(() => {
            this.activateDot(this.currentSlide);
            this.slides[this.currentSlide].style.opacity = '1';
            this.updateCounter(this.currentSlide);
        });
    }

    nextSlide() {
        const nextIndex = (this.currentSlide + 1) % this.totalSlides;
        this.goToSlide(nextIndex);
    }

    startSlideshow() {
        this.slideInterval = setInterval(() => this.nextSlide(), this.slideDuration);
    }

    resetSlideshow() {
        clearInterval(this.slideInterval);
        this.startSlideshow();
    }

    handleDotClick(index) {
        if (index !== this.currentSlide) {
            this.goToSlide(index);
            this.resetSlideshow();
        }
    }

    destroy() {
        clearInterval(this.slideInterval);
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const hero = document.querySelector('#hero-2470');
    if (hero) {
        new HeroSlideshow(hero);
    }
});
